module.exports = {
  Others: 'Others',
  YouToViewOrFiles: 'You do not have the authority to view or print other people\'s uploaded files.',
  BookingAgent: 'Booking Agent',
  BasicInformation: 'Basic Information',
  FileHistory: 'File History',
  Cancel: 'Cancel',
  Save: 'Save',
  SynchronizeFees: 'Synchronize Fees',
  ProjectNameCannotBeEmpty: 'Project name cannot be empty！',
  CustomerNameCannotBeEmpty: 'Customer name cannot be empty！',
  ProjectCycleCannotBeEmpty: 'Project cycle cannot be empty！',
  EndBeEarlierThanDate: 'End date cannot be earlier than start date！',
  AccountingCurrencyCannotBeEmpty: 'Accounting currency cannot be empty！',
  ProjectManagerCannotBeEmpty: 'Project manager cannot be empty！',
  ProjectDepartmentCannotBeEmpty: 'Project department cannot be empty！',
  ProjectCompanyCannotBeEmpty: 'Project company cannot be empty！',
  SaveSuccessfully: 'Save successfully',
  TheStatusCannotBeEdited: 'The current project status cannot be edited！',
  TheStatusCannotBeDeleted: 'The current project status cannot be deleted！',
  PleaseToDeleteTheNumber: 'Please confirm if you would like to delete the project with serial number',
  Prompt: 'Prompt',
  Confirm: 'Confirm',
  DeleteSuccessfully: 'Delete successfully',
  CancelledDeletion: 'Cancelled deletion',
  ProjectStatusCompleted: 'Project status completed',
  PleaseCanCloseTheNumber: 'Please confirm that you can close the serial number',
  ClosedSuccessfully: 'Closed successfully',
  ClosedCancelled: 'Closed cancelled',
  ProjectStatusInProgress: 'Project status in progress',
  PleaseNeedToReopenNumber: 'Please confirm that you need to reopen the serial number',
  SuccessfullyOpened: 'Successfully opened',
  CancelledOpening: 'Cancelled opening',
  PleaseSelectARecord: 'Please select a record！',
  DeletedSuccessfully: 'Deleted successfully',
  DeletionCancelled: 'Deletion cancelled',
  CancelledClosing: 'Cancelled closing',
  OpenedSuccessfully: 'Opened successfully',
  XNotAllowViewOrDownload: '{0} file is not allowed to be viewed or downloaded by anyone.',
  NoPermissionView: 'You don\'t have the permission to view or download {0} file',
  PleaseToDeleteTheProject: 'Please confirm if you would like to delete the serial number {0} project'
}
